import { FC } from 'react';
import type { LandingResults } from 'src/common/types/api/v4/search/v1/landing';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import { PATHS } from 'src/common/constants';
import BoatTypeCard from 'src/common/components/BoatTypeCard';
import { CarouselProvider } from 'src/common/providers/CarouselProvider';
import Carousel from 'src/common/components/dockyard/Carousel';
import CarouselButtons from 'src/common/components/dockyard/CarouselButtons';
import Button from 'src/common/components/ButtonDS22';
import styles from './LandingPageBoatTypes.module.scss';

type LandingPageBoatTypesProps = {
  ctaText: string;
  listingTypes: LandingResults['listing_types'];
  title: string;
};

const LandingPageBoatTypes: FC<LandingPageBoatTypesProps> = ({
  ctaText,
  listingTypes,
  title,
}) => (
  <PitchPageLayout
    backgroundColor="midnight02"
  >
    <div className={styles.root}>
      <CarouselProvider>
        <div className={styles.header}>
          <div className={styles.title}>
            <Typography type="h2" size="display-5">
              {title}
            </Typography>
          </div>
          <div className={styles.desktopButtons}>
            <CarouselButtons
              variant="primary-dark"
              spacing="together"
            />
          </div>
        </div>
        <Carousel>
          {listingTypes?.map((listing) => (
            <BoatTypeCard
              key={listing.slug}
              urlSegment={listing.slug}
              hasCta={false}
            />
          ))}
        </Carousel>
        <div className={styles.mobileButtons}>
          <CarouselButtons
            variant="primary-dark"
            spacing="together"
          />
        </div>
      </CarouselProvider>
      <Button
        type="link"
        variant="tertiary"
        href={PATHS.SEARCH}
        fitWidth="m"
      >
        {ctaText}
      </Button>
    </div>
  </PitchPageLayout>
);

export default LandingPageBoatTypes;
